import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { formatDateTime, formatFormula, getOperatorLabel, getPageNumbers, transformGrids } from "../utils";
import AdvancedSpreadsheet from "../components/AdvancedSpreadsheet";
import { AdvancedDrilldownGrid } from "../components/AdvancedDrilldownGrid";
import Select from "react-select";
import { ImpactSummaryTable } from "../components/ImpactSummaryTable";
import DynamicDataTable from "../components/DynamicDataTable.js";
import { apiFetch } from "../apiFetch.js";
import MetricCard from "../components/MetricCard.js";
import AnalysisHub from "../components/AnalysisHub.js";
import AnalysisCards from "../components/AnalysisCards.js";
import PaymentPartyCard from "../components/AnalysisCard/PaymentPartyCard.js";
import TransactionExplorerCard from "../components/AnalysisCard/TransactionExplorerCard.js";
import ColumnAnalysisCard from "../components/AnalysisCard/ColumnAnalysisCard.js";
import { BarChart3, Columns3, FileSearch } from "lucide-react";
import ReconciliationOverview from "../components/ReconciliationOverview.js";

export default function ReconciliationSummary() {
  //if (!data) return null;

  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const { state } = useLocation();
  const { configName } = useParams();
  const [filePath, setFilePath] = useState(null)
  const [showMatchedUnmatched, setShowMatchedUnmatched] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [selectedDataType , setSelectedDataType] = useState("matched");
  const [selectedRow, setSelectedRow] = useState(null);
  const [panelWidth, setPanelWidth] = useState(500); // default width
  const [tab, setTab] = useState("details");
  const [rowDetails, setRowDetails] = useState(null);   // API response
  const [loading, setLoading] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);
  const DEFAULT_LIMIT = 8;
  const [isBasicOpen, setIsBasicOpen] = useState(true);
  const [activeFilter, setActiveFilter] = useState(null);
  const [selectedColumn, setSelectedColumn] = useState(null);
  const [columnOptions, setColumnOptions] = useState([]);
  const [error, setError] = useState(null);
  const [drilDownData, setDrilDownData] = useState([]);
  const [tableHeading, setTableHeading] = useState("");
  const tableRef = useRef(null);
  const [pagination, setPagination] = useState({
  page: 1,
  limit: Number(process.env.REACT_APP_PAGINATION_LIMIT),
  total: 0,
  totalPages: 1,
});
  const DEFAULT_WIDTH = 400;
  let {
    totalRecords,
    matchRate,
    discrepancies,
    resolved,
    matchedCount,
    missMatchedCount,
  } = data;
  

  useEffect( () => {
    
    setActiveFilter(' ');
    setColumnOptions(
      [{
        value: 1,
        label: 'Transactional',
        fullData:'Transactional' 
      },
      {
        value: 2,
        label: 'Agency',
        fullData:'Agency' 
      } ]);

    if(state){
      
      try {
        
        apiFetch("file-mapping-config/summary-details",{
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            configId: state.file_mapping_id,
            uploadedFileId: state.id
          }),
        })
        .then((res) => res.json())
        .then((data) => { 
         
          let response = data.data;
          response['matched'] = response?.matchedCount;
          response['unmatched'] = response?.missMatchedCount;
          response['matchRate'] = response?.accuracy.toFixed(2);
          setData(response)
          setFilePath(response.file_path);
          setSelectedDataType("matched");
          cardClickHandler("Matched")
        }
        )
        .catch((err) => console.error(err));
        
      } catch (err) {
        console.error(err);
        alert("Process failed");
      } finally {
        // setRunning(false);
      }
      
    }
    
    
  }, []);
  

  const handleExport = () => {
    let  configId =  state.file_mapping_id;
    let uploadedFileId = state.id;
    window.open(
      `${process.env.REACT_APP_BACKEND_URL}file-mapping-config/export/${configId}/${uploadedFileId}`,
      "_blank"
    );
};

 /**=======================================
  *  UnMatched Data
  =========================================*/

  function cardClickHandler(type){

   
    pagination.page = 1;
    setPagination(pagination);
    switch (type) {
      case "Unmatched":
        setSelectedDataType("unmatched");
        onChartUnMatchedSelection()
        break;
      case "Matched":
        setSelectedDataType("matched");
        onChartMatchedSelection();
        break;
      case "Source Only":
        getSourceOnlyTransactions();
        break;
      case "Target Only":
        getTargetOnlyTransactions();
        break;
      case "Auto Resolved":
        getAutoResolvedTransactions()
        break;
      case "Resolved":
        getResolvedTransactions()
        break;
      case "Ingnored":
        getIngnoredTransactions();
        break;
    
      default:
        break;
    }
    scrollToViewTable();
  }

  function onChartUnMatchedSelection(){
    setSelectedDataType("unmatched")
    setShowMatchedUnmatched(true);
    setTableHeading("Unmatched")
  }

  function onChartMatchedSelection(){

    setSelectedDataType("matched")
    setShowMatchedUnmatched(true);
    setTableHeading("Matched")
  }

  function scrollToViewTable(){
    // Wait for React to render the filtered data
    setTimeout(() => {
      tableRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  }

/**=========================================
 * PAGINATION BUTTONS
 ==========================================*/
  const pages = getPageNumbers(pagination.page, pagination.totalPages);

  const handleNext = () => {
    if (pagination.page < pagination.totalPages) {
      pagination.page = pagination.page + 1;
      setPagination(pagination);
      openUnmatchedTable();
    }
  };

  const handlePrev = () => {
    if (pagination.page > 1) {
      pagination.page = pagination.page - 1;
      setPagination(pagination);
      openUnmatchedTable();
    }
  };

  const handlePageSizeChange = (e) => {
    const newLimit = Number(e.target.value);

    pagination.page = 1;
    pagination.limit = newLimit;
    setPagination(pagination);
    //  Reset to first page when page size changes
    openUnmatchedTable();
  };


    useEffect( () => {

       openUnmatchedTable();
    },[selectedDataType])


  async function openUnmatchedTable() {

    console.log(`openUnmatchedTable   selectedDataType  : ${selectedDataType}  `);

    let page = pagination.page;
    let limit = pagination.limit;
    try {
      const res = await apiFetch("file-mapping-config/"+selectedDataType,
      {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            configId: state.file_mapping_id,
            uploadedFileId: state.id,
            page,
            limit,
          }),
        }
    );

    const response = await res.json();
    setTableData(response.data || []);
    setPagination(response.pagination || {});
    
  } catch (err) {
    console.error(err);
  }
}

  /**=================================
   * 
   * @param {*} e 
   ==================================*/
  const handleMouseDown = (e) => {
  e.preventDefault();

  const startX = e.clientX;
  const startWidth = panelWidth;

  const handleMouseMove = (e) => {
    const newWidth = startWidth + (startX - e.clientX);

    //  set min/max limits
    if (newWidth > 300 && newWidth < 800) {
      setPanelWidth(newWidth);
    }
  };

  const handleMouseUp = () => {
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  document.addEventListener("mousemove", handleMouseMove);
  document.addEventListener("mouseup", handleMouseUp);
};

/**============================
 * ROW SELECTION
 =================================*/

const handleRowClick = async (row) => {
  setSelectedRow(row);     // open panel immediately
  setLoading(true);

  try {
        apiFetch( "es/get-details",{
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            configId: 1,// state.file_mapping_id,
            uploadedFileId: state.id,
            composite_key:row.composite_key+'::BL_DST'
          }),
        })
        .then((res) => res.json())
        .then((data) => { 
          let esData = data.data;
          console.log(`data ${JSON.stringify(esData[0]?._source)}`);
          
          setRowDetails(esData[0]?._source);   // full ES response
        }
      )
      .catch((err) => console.error(err));
      
    } catch (err) {
      console.error(err);
      alert("Process failed");
    } finally {
      setLoading(false);
    }
  
};
/**================ON COLUMN DROPDOWN SELECTION======================================= */
      useEffect(() => {
      if (!selectedColumn) return;

      let page = 1, limit = 10;
      const column = selectedColumn.fullData;
      alert(column);
      //setTableData([])
      //setLoading(true);

      apiFetch("file-mapping-config/get-invoice-list",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            configId: state.file_mapping_id,
            uploadedFileId: state.id,
            page,
            limit,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          setTableData(res.data || []);
          setPagination(res.pagination || {});
        })
        .catch(setError)
        .finally(() => setLoading(false));
    }, [selectedColumn]);
 /**========================================================= */

 /**========================================================= */
  
 const navigateToInvoiceView = async (row) => {
            navigate(`/programs/config/run/agency`, {
              state: {config_name:state.config_name,file_mapping_id:state.file_mapping_id,id:state.id,source_file_name:state.source_file_name,target_file_name:state.target_file_name},
        })
  }

  const navigateToTransactionView = async (row) => {
            navigate(`/programs/config/run/agency/details/all`, {
              state: {config_name:state.config_name,file_mapping_id:state.file_mapping_id,uploadedFileId:state.id,agency:"all",source_file_name:state.source_file_name,target_file_name:state.target_file_name},
        })
  }

  const navigateToColumnAnalysisView = async (row) => {
            navigate(`/programs/config/run/analysis`, {
              state: {config_name:state.config_name,file_mapping_id:state.file_mapping_id,id:state.id,source_file_name:state.source_file_name,target_file_name:state.target_file_name},
        })
  }
  
  /**================================================ */
  const getSourceOnlyTransactions = async (row) => {

    let page = pagination.page, limit = pagination.limit;
    
      apiFetch(
        
          "file-mapping-config/sourceOnly",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            configId: state.file_mapping_id,
            uploadedFileId: state.id,
            page,
            limit,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          setShowMatchedUnmatched(false);
          setTableData(res.data || []);
          setPagination(res.pagination || {});
           setTableHeading("Source Only")
        })
        .catch(setError)
        .finally(() => setLoading(false));
          
  }

  /**================================================== */
  const getTargetOnlyTransactions = async (row) => {
         
    let page = pagination.page, limit = pagination.limit;
    
      apiFetch(
       
          "file-mapping-config/targetOnly",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            configId: state.file_mapping_id,
            uploadedFileId: state.id,
            page,
            limit,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          setShowMatchedUnmatched(false);
          setTableData(res.data || []);
          setPagination(res.pagination || {});
          setTableHeading("Target Only")
          
        })
        .catch(setError)
        .finally(() => setLoading(false));
  }

 /**========================================================= */

 const getResolvedTransactions = async () => {
   getResolvedOrIngnoredTransactions("RESOLVED")
 }

 const getIngnoredTransactions = async () => {
  getResolvedOrIngnoredTransactions("IGNORED")
 }
 const getResolvedOrIngnoredTransactions = async (actonType) => {
         
    let page = pagination.page, limit = pagination.limit;
    
      apiFetch(
        
          "file-mapping-config/resolved-ignored",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            configId: state.file_mapping_id,
            uploadedFileId: state.id,
            actionType:actonType,
            page,
            limit,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          setShowMatchedUnmatched(false);
          setTableData(res.data || []);
          setPagination(res.pagination || {});
          setTableHeading(actonType)
          
        })
        .catch(setError)
        .finally(() => setLoading(false));
  }


  const getAutoResolvedTransactions = async () => {
         
    let page = pagination.page, limit = pagination.limit;
    
      apiFetch(
        
          "file-mapping-config/auto-resolved",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            configId: state.file_mapping_id,
            uploadedFileId: state.id,
            page,
            limit,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          setShowMatchedUnmatched(false);
          setTableData(res.data || []);
          setPagination(res.pagination || {});
          setTableHeading("Auto Resloved")
        })
        .catch(setError)
        .finally(() => setLoading(false));
  }

  /**============================================
   * Download Uploaded Files
   ================================================*/
   const downloadFile = () => {
    let  configId =  state.file_mapping_id;
    let uploadedFileId = state.id;
    let type = 'source';
    window.open(
      `${process.env.REACT_APP_BACKEND_URL}file-mapping-config/download/${type}/${uploadedFileId}`,
      "_blank"
    );
};



  return (
    <div className="bg-gray-50 min-h-screen p-6 space-y-6">

      {/* HEADER */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold">Reconciliation Summary</h1>
          {/* <p className="text-gray-500 text-sm">
            Operations &gt; Runs &gt; Run #{data.runId}
          </p> */}
        </div>

        <div className="flex gap-3">
          {/* <button className="px-4 py-2 border rounded-lg">Share</button> */}
          <button className="px-4 py-2 bg-blue-600 text-white rounded-lg" onClick={handleExport}>
            Export Report
          </button>         
        </div>
      </div>

      {/* STATUS */}
      <div>
        {/* <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm">
          ● Completed Successfully
        </span> */}
        {/* <h2 className="text-3xl font-bold mt-2">
          Run Summary: {data.date}
        </h2> */}
        <p className="text-gray-500 font-bold mt-1">
          {state.config_name} : {formatDateTime(data.createdAt)}
        </p>
        <div className="flex flex-wrap gap-2 mt-3">
                        <div className="text-xs font-medium text-slate-700 truncate">
                          Source File : {state.source_file_name}
                        </div>
                        <div className="text-xs font-medium text-slate-700 truncate">
                         Target File : {state.target_file_name}
                        </div>

                    </div>
      </div>

      {/* CARDS */}
      <div className="bg-white rounded-2xl border border-slate-200 p-4 shadow-sm">
                  <ReconciliationOverview stats={{
                    total: data?.sourceUniqueCount,
                    matched: data?.matchedCount,
                    unmatched: data?.missMatchedCount,
                    sourceOnly: data?.sourceOnlyCount,
                    targetOnly: data?.targetOnlyCount,
                    sourceRecords: data?.sourceUniqueCount,
                    targetRecords: data?.targetUniqueCount,
                    sourceParty: data?.sourceInvoiceCount,
                    targetParty: data?.targetInvoiceCount,
                    handleSummaryClick:cardClickHandler
                  }}></ReconciliationOverview>

        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-8 gap-4">
          {/* <MetricCard title="Matched" value={data?.matchedCount}  desc = "Transactions" color="text-emerald-600" bg="bg-emerald-50" callback={cardClickHandler}/>
          <MetricCard title="Unmatched" value={data?.missMatchedCount}  desc = "Transactions" color="text-rose-600" bg="bg-rose-50" callback={cardClickHandler}/>
          <MetricCard title="Source Unique" value={data?.sourceUniqueCount}  desc = "Transactions" color="text-slate-700" bg="bg-slate-100"/>
          <MetricCard title="Target Unique" value={data?.targetUniqueCount}  desc = "Transactions" color="text-slate-700" bg="bg-slate-100"/>
          <MetricCard title="Source Only" value={data?.sourceOnlyCount}  desc = "Transactions" color="text-amber-600" bg="bg-amber-50" callback={cardClickHandler}/>
          <MetricCard title="Target Only" value={data?.targetOnlyCount}  desc = "Transactions" color="text-rose-600" bg="bg-rose-50" callback={cardClickHandler}/>
          <MetricCard title="Source" value={data?.sourceInvoiceCount}  desc = "Payment Party" color="text-amber-600" bg="bg-amber-50"  callback={navigateToInvoiceView}/>
          <MetricCard title="Target" value={data?.targetInvoiceCount} desc = "Payment Party" color="text-rose-600" bg="bg-rose-50"/> */}
        </div>
      </div>
      <div className="bg-white rounded-2xl border border-slate-200 p-4 shadow-sm">
        {/* <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-8 gap-4"> */}
          {/* <MetricCard title="Auto Resolved" value={data?.autoResolvedCount}  desc = "Transactions" color="text-emerald-600" bg="bg-emerald-50" callback={cardClickHandler}/>
          <MetricCard title="Resolved" value={data?.resolvedCount}  desc = "Transactions" color="text-rose-600" bg="bg-rose-50" callback={cardClickHandler}/>
          <MetricCard title="Ingnored" value={data?.ingnoredCount}  desc = "Transactions" color="text-slate-700" bg="bg-slate-100" callback={cardClickHandler}/>
          */}
          <AnalysisHub analysisCards={[
                        {
                          icon: <BarChart3 size={30} className="text-blue-600" />,
                          title: "Payment Party Analysis",
                          description:
                            "Group reconciliation results by payment party and identify mismatches.",
                          button: "View Analysis",
                          color: "bg-blue-50",
                          onClick: navigateToInvoiceView,
                          stats:{
                            matched:data?.matchedInvoiceCount,
                            unmatched:data?.unmatchedInvoiceCount
                          },
                          type:"payment-party"
                        },
                        {
                          icon: <FileSearch size={30} className="text-green-600" />,
                          title: "Transaction Explorer",
                          description:
                            "Browse every transaction with reconciliation status and filters.",
                          button: "Open Explorer",
                          color: "bg-green-50",
                          onClick: navigateToTransactionView,
                          stats:{
                            matched:data?.matchedCount,
                            unmatched:data?.missMatchedCount
                          },
                          type:"transaction-explorer"
                        },
                        {
                          icon: <Columns3 size={30} className="text-orange-600" />,
                          title: "Column Mismatch Analysis",
                          description:
                            "Analyze mismatches column-by-column to identify high impact fields.",
                          button: "Analyze Columns",
                          color: "bg-orange-50",
                          onClick: navigateToColumnAnalysisView,
                           stats:{
                            columnName:"Column",
                            unmatched:data?.missMatchedCount
                          },
                          type:"column-mismatch"
                          
                        },
                      ]}>
          </AnalysisHub>
          {/* <AnalysisCards cards={[
                    {
                      title: "Payment Party Analysis",
                      subtitle: "Group mismatches by payment party",
                      button: "View Analysis",
                      icon: BarChart3,
                      iconBg: "bg-emerald-50",
                      iconColor: "text-emerald-500",
                      buttonClass:
                        "bg-emerald-100 text-emerald-700 hover:bg-emerald-200",
                      border: "",
                      onClick:navigateToInvoiceView
                    },
                    {
                      title: "Column-wise Mismatches",
                      subtitle: "Analyze mismatches by columns/fields",
                      button: "View Columns",
                      icon: Columns3,
                      iconBg: "bg-violet-50",
                      iconColor: "text-violet-600",
                      buttonClass:
                        "bg-violet-600 text-white hover:bg-violet-700",
                      border: "border-2 border-violet-400",
                      onClick:navigateToColumnAnalysisView
                    },
                    {
                      title: "Transaction Explorer",
                      subtitle:
                        "Search every transaction and reconciliation state",
                      button: "Open Explorer",
                      icon: FileSearch,
                      iconBg: "bg-blue-50",
                      iconColor: "text-blue-500",
                      buttonClass:
                        "bg-blue-600 text-white hover:bg-blue-700",
                      border: "",
                      onClick:navigateToTransactionView
                    },
                  ]}>
            </AnalysisCards> */}
          {/* <div className="grid grid-cols-12 gap-6">

              <div className="col-span-4">
                  <PaymentPartyCard onClick={navigateToInvoiceView} />
              </div>

              <div className="col-span-4">
                  <TransactionExplorerCard onClick={navigateToTransactionView} />
              </div>
              <div className="col-span-4">
                  <ColumnAnalysisCard onClick={navigateToColumnAnalysisView}/>
              </div>

          </div> */}
        {/* </div> */}
      </div>

      {tableData && tableData.length>0 &&  (
        <div className="bg-white p-6 rounded-xl shadow mt-6" ref={tableRef}>

          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-bold text-red-600">
              {tableHeading} Records ({pagination.total})
            </h3>

            {/* <button
              onClick={() => setShowMatchedUnmatched(false)}
              className="text-sm text-gray-500"
            >
              Close ✕
            </button> */}
          </div>

          
            <>
               {showMatchedUnmatched && <SpreadsheetTable
                  data={tableData}
                  onRowClick={handleRowClick}   //  pass handler
                />} 
                {!showMatchedUnmatched && 
                <DynamicDataTable data={tableData}></DynamicDataTable>} 
                {/* <AdvancedSpreadsheet
                  data={tableData}
                  onRowClick={handleRowClick}   //  pass handler
                /> */}

                {/* <AdvancedDrilldownGrid data={tableData} loading={loading} /> */}
                
                

                {/**SIDE PANEL */}
                {selectedRow && (
                <>
                  {/* Overlay */}
                  <div
                    className="fixed inset-0 bg-black bg-opacity-30 z-40"
                    onClick={() => setSelectedRow(null)}
                   

                    
                  />

                  {/* PANEL */}
                  <div
                    className="fixed top-0 right-0 h-full bg-white shadow-lg z-50 flex"
                    style={{ width: panelWidth }
                  }
                  >

                    {/* DRAG HANDLE */}
                    <div
                      onMouseDown={handleMouseDown}
                      onDoubleClick={() => setPanelWidth(DEFAULT_WIDTH)}
                      className="w-1 cursor-col-resize bg-gray-300 hover:bg-blue-400"
                      
                    />

                    {/* CONTENT */}
                    <div className="flex-1 p-4 overflow-auto">

                      <div className="flex justify-between items-center mb-4">
                        <h2 className="text-lg font-semibold">Row Details</h2>
                        <button onClick={() => setSelectedRow(null)}>✕</button>
                      </div>

                      {/* BASIC INFO */}
                        <div className="border rounded-lg">

                          {/* HEADER (CLICKABLE) */}
                          <div
                            onClick={() => setIsBasicOpen(!isBasicOpen)}
                            className="flex justify-between items-center cursor-pointer bg-gray-100 px-3 py-2"
                          >
                            <span className="font-semibold">Basic Info</span>
                            <span className="text-sm">
                              {isBasicOpen ? "▲" : "▼"}
                            </span>
                          </div>

                          {/* CONTENT */}
                          {isBasicOpen && (
                            <div className="p-3 text-sm space-y-2">

                              <div><b>Key:</b> {selectedRow.composite_key}</div>

                              {Object.keys(selectedRow)
                                .filter((k) => k.startsWith("s_"))
                                .map((col) => {
                                  const name = col.replace("s_", "");
                                  const sVal = selectedRow[`s_${name}`];
                                  const tVal = selectedRow[`t_${name}`];
                                  const status = selectedRow[`c_${name}`];

                                  return (
                                    <div key={name} className="border-b pb-2">
                                      <div className="font-medium">{name}</div>
                                      <div>Source: {sVal}</div>
                                      <div>Target: {tVal}</div>
                                      <div
                                        className={
                                          status === "FALSE"
                                            ? "text-red-600"
                                            : "text-green-600"
                                        }
                                      >
                                        {status}
                                      </div>
                                    </div>
                                  );
                                })}

                            </div>
                          )}

                        </div>
                     

                      {/*  ADD GRID PANEL HERE */}
                      {rowDetails?.applicableGrids && (
                        <div className="mt-6">
                          <h3 className="text-md font-semibold mb-2">Grid Calculations</h3>
                          <GridPanel data={rowDetails} />
                        </div>
                      )}

                    </div>
                  </div>
                </>
              )}

                
            </>          
              {/* <AdvancedSpreadsheet data={tableData} /> */}

          {/* OPTIONAL FULL PAGE */}
          {/* <div className="mt-4 text-right">
            <button
              onClick={() =>
                window.open(
                  `/reconciliation-summary-full/${state.id}`,
                  "_blank"
                )
              }
              className="text-blue-600 font-medium"
            >
              Open Full Page →
            </button>
          </div> */}

          {/* PAGINATION */}
          <div className="flex justify-between items-center mt-4">

              {/* LEFT */}
              <div className="text-sm text-gray-600">
                Showing{" "}
                {(pagination.page - 1) * pagination.limit + 1}
                {" - "}
                {Math.min(pagination.page * pagination.limit, pagination.total)}
                {" of "}
                {pagination.total}
              </div>

              {/* RIGHT */}
              <div className="flex items-center gap-4">

                {/* Page Size */}
                <div className="flex items-center gap-2">
                  <span className="text-sm">Rows:</span>
                  <select
                    value={pagination.limit}
                    onChange={handlePageSizeChange}
                    className="border px-2 py-1 rounded"
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                </div>

                {/* Prev */}
                <button
                  onClick={handlePrev}
                  disabled={pagination.page === 1}
                  className="px-3 py-1 border rounded disabled:opacity-50"
                >
                  Prev
                </button>

                {/* Page Info */}
                  {pages.map((p, i) =>
                    p === "..." ? (
                      <span key={i} className="px-2">...</span>
                    ) : (
                      <button
                        key={i}
                        onClick={() => {
                          pagination.page = p;
                          
                          setPagination(pagination);
                          openUnmatchedTable()}
                        }
                        className={`px-2 py-1 border rounded ${
                          p === pagination.page ? "bg-blue-500 text-white" : ""
                        }`}
                      >
                        {p}
                      </button>
                    )
                  )}

                {/* Next */}
                <button
                  onClick={handleNext}
                  disabled={pagination.page === pagination.totalPages}
                  className="px-3 py-1 border rounded disabled:opacity-50"
                >
                  Next
                </button>

              </div>
          </div>
         

        </div>
      )}
    </div>
  );
}


/* BREAKDOWN ITEM */
function BreakdownItem({ title, desc, value, color }) {
  return (
    <div className="bg-gray-50 p-4 rounded-lg flex justify-between items-center">
      <div>
        <p className="font-medium">{title}</p>
        <p className="text-xs text-gray-500">{desc}</p>
      </div>

      <div className="text-right">
        <p className="font-bold">{value}</p>
        <div className="w-24 h-2 bg-gray-200 rounded mt-2">
          <div className={`h-2 rounded ${color}`} style={{ width: "60%" }}></div>
        </div>
      </div>
    </div>
  );
}

function UnmatchedTable({ data ,onRowClick}) {
  if (!data || data.length === 0) return null;

  return (
    <div className="max-h-[500px] overflow-auto border rounded-lg">
      <table className="w-full text-sm table-fixed">

        {/* HEADER */}
        <thead className="sticky top-0 bg-slate-100">
          <tr>
            <th className="px-3 py-2">Key</th>
            <th>Column</th>
            <th>Source</th>
            <th>Target</th>
            <th>Status</th>
          </tr>
        </thead>

        <tbody>
          {data.map((row, rowIndex) => {

            const columns = Object.keys(row).filter(
              (key) => key.startsWith("c_") && row[key] === "FALSE"
            );
            let self = this;
            return columns.map((colKey, i) => {
              const base = colKey.replace("c_", "");

              const sourceVal = row[`s_${base}`];
              const targetVal = row[`t_${base}`];
             


              return (
                 <tr key={`${rowIndex}-${i}`} className="border-t hover:bg-slate-50">
                  {/* <tr key={i}
                    className={`hover:bg-gray-50 ${
                      selectedRow?.composite_key === row.composite_key
                        ? "bg-blue-50"
                        : ""
                    }`}
                  > */}

                  {/* KEY */}
                 <td
                    className="border px-3 py-2 font-medium bg-white sticky left-0 z-10 cursor-pointer text-blue-600"
                    onClick={() =>  onRowClick(row)}
                  >
                    {row.composite_key}
                  </td>

                  {/* COLUMN NAME */}
                  <td className="font-semibold">{base}</td>

                  {/* SOURCE */}
                  <td className="text-blue-600 break-words">
                    {sourceVal}
                  </td>

                  {/* TARGET */}
                  <td className="text-green-600 break-words">
                    {targetVal}
                  </td>

                  {/* STATUS */}
                  <td className="text-red-500 font-bold">
                    ❌ Mismatch
                  </td>

                </tr>
              );
            });
          })}
        </tbody>

      </table>
    </div>
  );
}

function SpreadsheetTable({ data ,onRowClick}) {
  if (!data) return <div className="p-4">Loading...</div>;
  if (data.length === 0) return <div className="p-4">No mismatches found</div>;

  const columns = Object.keys(data[0])
    .filter((key) => key.startsWith("s_"))
    .map((key) => key.replace("s_", ""));

  return (
    <div className="border rounded-lg overflow-auto max-h-[500px]">

      <table className="min-w-full text-sm border-collapse table-fixed">

        {/* HEADER */}
        <thead className="sticky top-0 bg-gray-100 z-20">
          <tr>
            <th className="border px-3 py-2 sticky left-0 bg-gray-100 z-20 min-w-[150px]">
              Key
            </th>

            {columns.map((col) => (
              <th key={col} className="border px-3 py-2 text-left min-w-[180px]">
                {col}
              </th>
            ))}
          </tr>
        </thead>

        {/* BODY */}
        <tbody>
          {data.map((row, i) => (
            <tr key={i} className="hover:bg-gray-50">

              <td
                onClick={() => onRowClick(row) }   //  use prop
                className="cursor-pointer text-blue-600 border px-3 py-2 font-medium bg-white sticky left-0 z-10"
              >
                {row.composite_key}
              </td>

              {columns.map((col) => {
                const source = row[`s_${col}`] ?? "";
                const target = row[`t_${col}`] ?? "";
                const status = row[`c_${col}`] ?? "TRUE";

                return (
                  <td
                    key={col}
                    className={`border px-3 py-2 min-w-[180px] ${
                      status === "FALSE"
                        ? "bg-red-100 text-red-700"
                        : "bg-green-50 text-gray-800"
                    }`}
                  >
                    <div className="flex flex-col">
                      <span>{source}</span>

                      {status === "FALSE" && (
                        <span className="text-xs text-gray-500">
                          → {target}
                        </span>
                      )}
                    </div>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>

      </table>
    </div>
  );
}

const GridPanel = ({ data }) => {
  const grids = transformGrids(data);
  const [openIndex, setOpenIndex] = useState(null);

  return (

    <div className="space-y-4">
      {grids.map((grid, i) => (
        <div key={i} className="bg-white rounded-xl shadow border">

          {/* HEADER */}
          <div className="px-4 py-2 border-b font-semibold text-blue-700">
            {grid.gridName}
          </div>

          {/* FORMULA */}
          <div className="px-4 py-3">
            <div className="text-xs text-gray-500 mb-1">📐 Formula</div>
            <div className="bg-gray-900 text-green-400 p-3 rounded font-mono text-xs">
              {grid.formula
                ? formatFormula(grid.formula)
                : "No formula"}
            </div>
          </div>

          {/* OUTPUTS */}
          <div className="px-4 pb-3">
            <div className="text-xs text-gray-500 mb-1">📊 Outputs</div>

            <div className="space-y-1">
              {grid.outputs?.map((item, idx) => (
                <div
                  key={idx}
                  className="flex justify-between bg-gray-50 px-3 py-2 rounded"
                >
                  <span className="text-gray-700">{item.outputName}</span>
                  <span className="font-semibold text-blue-600">
                    {item.outputValue}
                  </span>
                </div>
              ))}
            </div>
          </div>

        </div>
      ))}
    </div>
      
  );
};

const FormulaNode = ({ node }) => {
  if (!node) return null;

  // VARIABLE
  if (node.var) {
    return (
      <div className="px-2 py-1 bg-blue-100 rounded text-xs text-center">
        {node.var}
      </div>
    );
  }

  // NUMBER
  if (typeof node === "number") {
    return (
      <div className="px-2 py-1 bg-gray-200 rounded text-xs">
        {node}
      </div>
    );
  }

  // OPERATOR
  const operator = Object.keys(node)[0];
  const children = node[operator];

  return (
    <div className="flex flex-col items-center">

      {/* OPERATOR NODE */}
      <div className="px-3 py-1 bg-black text-white rounded text-xs mb-2">
        {getOperatorLabel(operator)}
      </div>

      {/* CHILDREN */}
      <div className="flex gap-4">
        {children.map((child, i) => (
          <FormulaNode key={i} node={child} />
        ))}
      </div>

    </div>
  );
};

const Card = ({ title, desc, percent, icon,onClick }) => (
  <div  onClick={onClick} className="rounded-2xl border p-6 min-h-[160px] shadow hover:scale-[1.02] cursor-pointer transition">
    <div className="flex justify-between items-start mb-4">
      <div className="p-3 bg-blue-100 rounded-lg">
        <span className="material-symbols-outlined text-blue-600 text-xl">
          {icon}
        </span>
      </div>

      <div className="flex flex-col items-end">
        <span className="text-[10px] font-bold text-gray-500 uppercase">
          Impact Prob.
        </span>
        <span className="font-bold text-blue-600">
          {percent ? percent.toFixed(2) + "%" : "NA"}
        </span>
      </div>
    </div>

    <h4 className="font-bold text-gray-800 text-lg mb-1">{title}</h4>
    <p className="text-sm text-gray-500">{desc}</p>
  </div>
);

